<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编码">
              <a-input v-model="query.classNo" placeholder="请输入分类编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="18" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>

              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ execlForm: true })"
                v-action:upload>下载模板</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()" :loading="exportLoading"
                v-action:export>导出</a-button>

              <a-upload name="file" :multiple="false" @change="changeFile" :file-list="fileList"
                :customRequest="customRequest" v-action:import>
                <a-button style="margin-left: 8px" type="primary">导入</a-button>
              </a-upload>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <a-tag color="blue" slot="status" slot-scope="text">{{ text ? 'yes' : 'NO' }}</a-tag>
      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
       
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码" hasFeedback>
          <a-input :disabled="this.isUpdate" placeholder="分类编码"
            v-decorator="['classNo', { rules: [{ required: true, message: '分类编码' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="口径" hasFeedback>
          <a-input placeholder="口径" v-decorator="['caliber', { rules: [{ required: true, message: '口径' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装地址" hasFeedback>
          <a-input placeholder="安装地址" v-decorator="['address', { rules: [{ required: false, message: '安装地址' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌">
          <a-input placeholder="品牌" v-decorator="['brand', { rules: [{ required: false, message: '请输入品牌' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input placeholder="备注" v-decorator="['remark', { rules: [{ required: false, message: '请输入备注' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="坐标点X">
          <a-input placeholder="坐标点X" v-decorator="[
            'coordinatePointX',
            { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入坐标点X' }] },
          ]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="坐标点Y">
          <a-input placeholder="坐标点Y" v-decorator="[
            'coordinatePointY',
            { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入坐标点Y' }] },
          ]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地面高程m">
          <a-input placeholder="地面高程m" v-decorator="[
            'groundElevation',
            { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入地面高程m' }] },
          ]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联片区">
          <a-tree-select :tree-data="zoneTreeData" multiple
            v-decorator="['zoneId', { rules: [{ required: true, message: '请选择片区' }] }]" style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
            :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search treeNodeFilterProp="title"></a-tree-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <history-modal ref="historyModal"></history-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import HistoryModal from '../module/waterHistoryModal'
import importModal from '@/views/pipenetwork/module/ImportModal'

const STATUS = {
  1: '正常',
  2: '禁用',
}
const columns = [

  {
    title: '分类编码',
    dataIndex: 'classNo',
  },
  {
    title: '口径',
    dataIndex: 'caliber'
  },
  {
    title: '安装地址',
    dataIndex: 'address'
  },
  {
    title: '品牌',
    dataIndex: 'brand'
  },
  {
    title: '坐标X',
    dataIndex: 'coordinatePointX',
  },
  {
    title: '坐标Y',
    dataIndex: 'coordinatePointY',
  },
  {
    title: '地面高程',
    dataIndex: 'groundElevation',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },
  {
    title: '关联片区',
    dataIndex: 'zoneName',
  },
  {
    title: '备注',
    dataIndex: 'remark',
  },
  {
    title: '操作',
    width: '150px',

    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: {
    importModal,
    HistoryModal,
  },
  mixins: [mixinViewModule],
  name: 'waterAssociatedPoints',
  data () {
    return {
      importLoading: false,
      downloadTemplateUrl: 'pipe-network/water_associated_points/template/download', // 水表模板
      downloadTemplateName: '分界阀门导入模板.xlsx',
      fileList: [],
      exportDataUrl: 'pipe-network/water_associated_points/export',
      exportFileName: '分界阀门表.xlsx',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryUrl: 'pipe-network/water_associated_points/page',
      addOrUpdateUrl: 'pipe-network/water_associated_points',
      queryOneUrl: 'pipe-network/water_associated_points',
      deleteUrl: 'pipe-network/water_associated_points',
      downloadUrl: 'pipe-network/water_associated_points/export',
      zoneTreeData: [], // 分区数据选项
      treeDefaultExpandedKeys: [], // 默认展开的树节点
      query: {
        classNo: '',
        appearanceNo: '',
        tenantId: this.$store.state.user.info.tenantId,
        waterBigStatus: '',
        appendage: '分界阀门'
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
    }
  },
 
  created () {
    this.getZoneData()
  },

  methods: {
    // 重写 addOrUpdateHandle 方法，处理编辑时的数据回显
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              // 将后台返回的分号分隔字符串转换为数组
              if (data.zoneId && typeof data.zoneId === 'string') {
                data.zoneId = data.zoneId.split(';').filter(item => item.trim())
              } else if (data.zoneId && !Array.isArray(data.zoneId)) {
                data.zoneId = [data.zoneId]
              }
              this.addOrUpdateForm.setFieldsValue(data)
            })
            .catch(() => { })
        }
      })
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            appendage: '分界阀门',
            ...values,
          }
          // 将关联片区数组转换为分号分隔的字符串
          if (params.zoneId && Array.isArray(params.zoneId)) {
            params.zoneId = params.zoneId.join(';')
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    // 重置
    resetList () {
      this.query.appendage = '分界阀门'
      this.pagination.current = 1
      this.queryList()
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
        this.chuli(this.zoneTreeData)
      })
    },
    chuli (n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    historyData () {
      this.$refs.historyModal.show()
    },
    // 关闭选择分区页面时
    close (val) {
      console.log(val)
      this.zoneId = val
      this.openSelectFile = true
    },
    // importHandle() {
    //   console.log('导入按钮')
    //   this.$refs.importModal.show()
    // },
    changeFile (info) { },
    customRequest (data) {
      // 上传提交
      console.log('123')
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/water_associated_points/import/boundary_valve',
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
